<template>
  <!-- 首页 -->
  <div>
    <div class="main">
      <!-- 第一行 -->
      <el-row>
        <el-col :span="13" :offset="1">
          <div style="font-size: 38px">
            <span style="font-size: 52px;">欢迎来到<b style="font-size: 72px;color:#FFC300;">星系马戏团</b> </span>
          </div>
        </el-col>
      </el-row>
      <!-- 第二行 -->
      <el-row>

        <el-col :span="9" :offset="1">
          <div class="start-block">
            <div class="project-pick">
              <span class="project-pick-label">选择标注项目</span>
              <el-select
                v-model="selectedProjectId"
                class="project-pick-select"
                placeholder="请选择要标注的数据集"
                clearable
                :loading="projectsLoading"
                :disabled="annotationProjects.length === 0"
                @change="onProjectPickChange"
              >
                <el-option
                  v-for="p in annotationProjects"
                  :key="p.id"
                  :label="projectOptionLabel(p)"
                  :value="p.id"
                />
              </el-select>
              <span v-if="selectedProjectHint" class="project-pick-hint">{{ selectedProjectHint }}</span>
            </div>

            <div class="but" :class="{ 'but--loading': startingExplore }" @click="ks">
              <span style="font-size:20px">开始寻找异常星系</span>
              <span style="font-size:12px">Start Exploring Now</span>
              <span style="font-size:16px;color:greenyellow">本赛季由{{ text.sponsor }}赞助</span>
            </div>

          </div>
        </el-col>

      </el-row>

      <el-row>
        <el-col :span="2" :offset="1">
          <div @click="operate" class="butt">
            <span><b>操作指南</b></span>
          </div>
        </el-col>

        <el-col :span="2" style="margin-left:1%">
          <div @click="star" class="butt">
            <span> <b>了解更多</b></span>
          </div>
        </el-col>

        <el-col :span="2" style="margin-left:1%">
          <div class="butt1">
            <span> <a href="https://gitee.com/zhou--pu/galaxycircus-public/issues"><b>意见反馈</b></a></span>
          </div>
        </el-col>
      </el-row>

    </div>

    <div class="main-one">
      <!-- 第一行 -->
      <el-row>
        <el-col :span="8" :offset="1">
          <div class="jj">
            <h3>{{ text.introduce.name }}:</h3>
          </div>
        </el-col>
      </el-row>
      <!-- 第二行 -->
      <el-row>
        <el-col :span="14" :offset="1">
          <p v-text="text.introduce.text"
            style="font-size: 14px;color:rgb(204,204,204);text-indent: 2em;text-align: justify;line-height: 25px;">
          </p>

          <p v-text="text.introduce.text1"
            style="font-size: 14px;color:rgb(204,204,204);text-indent: 2em;text-align: justify;line-height: 25px;">
          </p>

          <p v-text="text.introduce.text2"
            style="font-size: 14px;color:rgb(204,204,204);text-indent: 2em;text-align: justify;line-height: 25px;">
          </p>

          <p v-text="text.introduce.text3"
            style="font-size: 14px;color:rgb(204,204,204);text-indent: 2em;text-align: justify;line-height: 25px;">
          </p>
          <el-col :span="4" style="margin-left:70%">
            <div @click="star" class="butt-one">
              <span>了解更多</span>
            </div>
          </el-col>

        </el-col>
        <el-col :span="8" :offset="1">
          <div class="img-one"><img :src="text.introduce.src" alt="" /></div>
          <p style="font-size: 14px; position: relative; right: 7px;">
（图片来源于 <a href="https://science.nasa.gov/missions/hubble/ai-unlocks-hundreds-of-cosmic-anomalies-in-hubble-archive/" target="_blank"> AI Unlocks Hundreds of Cosmic Anomalies in Hubble Archive </a>）
</p>
        </el-col>
      </el-row>

      <!-- 第二行 -->
      <el-row style="margin-top: 7px">
        <el-col :span="7" :offset="1">
          <div class="jj">
            <h3>{{ text.dataintroduce.name }}:</h3>
          </div>
        </el-col>
      </el-row>

      <el-row>
        <el-col :span="14" :offset="1">
          <p v-text="text.dataintroduce.text"
            style="margin-top:4px;font-size: 14px; line-height: 25px; text-indent: 2em;text-align: justify; color:rgb(204,204,204)">
          </p>

          <p v-text="text.dataintroduce.text1"
            style="margin-top:4px;font-size: 14px; line-height: 25px; text-indent: 2em;text-align: justify; color:rgb(204,204,204)">
          </p>

          <p v-text="text.dataintroduce.text2"
            style="margin-top:4px;font-size: 14px; line-height: 25px; text-indent: 2em;text-align: justify; color:rgb(204,204,204)">
          </p>

          <p v-text="text.dataintroduce.text3"
            style="margin-top:4px;font-size: 14px; line-height: 25px; text-indent: 2em;text-align: justify; color:rgb(204,204,204)">
          </p>

          <p v-text="text.dataintroduce.text4"
            style="margin-top:4px;font-size: 14px; line-height: 25px; text-indent: 2em;text-align: justify; color:rgb(204,204,204)">
          </p>

          <p v-text="text.dataintroduce.text5"
            style="margin-top:4px;font-size: 14px; line-height: 25px; text-indent: 2em;text-align: justify; color:rgb(204,204,204)">
          </p>

          <p v-text="text.dataintroduce.text6"
            style="margin-top:4px;font-size: 14px; line-height: 25px; text-indent: 2em;text-align: justify; color:rgb(204,204,204)">
          </p>
          <el-col :span="4" style="margin-left:70%">
            <div @click="shuju" class="butt-two">
              <span>了解更多</span>
            </div>
          </el-col>

        </el-col>
        <el-col :span="8" :offset="1">
          <div class="img-two"><img :src="text.dataintroduce.src" alt="" /></div>
          <p style="margin-top: 305px; position: relative; right: 6px; font-size: 14px;">
（图片来源于 <a href="https://finance.sina.com.cn/tech/2021-06-26/doc-ikqcfnca3316940.shtml" target="_blank">超弥散星系（UDG）NGC1052-DF2（DF2）</a>）
</p>
          </p>
        </el-col>
      </el-row>
    </div>
    <!-- 排行榜和统计 -->
    <el-row>
      <el-col :span="24">
        <div class="bg">
          <b style="font-size: 26px">{{ statsProjectTitle }} <span style="font-size: 18px">（每30分钟更新）</span> </b>
        </div>
      </el-col>
    </el-row>

    <div class="rank-section">
      <el-row>
        <!-- 左侧统计 -->
        <el-col :span="5" :offset="2">
          <div class="stats-panel">
            <div class="stats-title">项目统计</div>
            <div class="stats-item">
              <span>总用户数</span>
              <b>{{ user }}</b>
            </div>
            <div class="stats-item">
              <span>标注次数</span>
              <b>{{ marking }}</b>
            </div>
            <div class="stats-item">
              <span>标注图片数</span>
              <b>{{ images }}</b>
            </div>
            <div class="progress-box">
              <div class="progress-title">数据标注完成进度</div>
              <div class="progress-text">待完成批次/已完成批次：{{ pendingData }} / {{ batchDone }}</div>
              <div class="progress-circle-wrap">
                <el-progress type="circle" :percentage="completionPercent" :width="130" :stroke-width="10" color="#ffc300"></el-progress>
              </div>
            </div>
            <div class="stats-item">
              <span>页面访问数</span>
              <b>{{ countp }}</b>
            </div>
          </div>
        </el-col>

        <!-- 分类数排行榜 -->
        <el-col :span="6" :offset="2" class="rank-col">
          <el-row>
            <el-col>
              <div class="top">
                <el-tooltip class="item" effect="dark" content="用户分类的总次数" placement="top">
                  <el-button class="button">分类数</el-button>
                </el-tooltip>
              </div>
            </el-col>
          </el-row>

          <el-row>
            <el-col>
              <div class="biao">
                <el-table class="b" :data="tableData1">
                  <el-table-column type="index" label="序号" width="80"></el-table-column>
                  <el-table-column prop="name" label="姓名"></el-table-column>
                  <el-table-column prop="classifyTimes" label="分类数"></el-table-column>
                </el-table>
              </div>
            </el-col>
          </el-row>
        </el-col>

        <!-- 异常数排行 -->
        <el-col :span="6" :offset="2" class="rank-col">
          <el-row>
            <el-col>
              <div class="top">
                <el-tooltip class="item" effect="dark" content="用户分类找到的总异常数" placement="top">
                  <el-button class="button">异常数</el-button>
                </el-tooltip>
              </div>
            </el-col>
          </el-row>
          <el-row>
            <el-col>
              <div class="biao">
                <el-table class="b" :data="tableData2">
                  <el-table-column type="index" label="序号" width="80"></el-table-column>
                  <el-table-column prop="name" label="姓名"></el-table-column>
                  <el-table-column prop="classifyTotalIrr" label="异常数"></el-table-column>
                </el-table>
              </div>
            </el-col>
          </el-row>
        </el-col>

        <!-- 分类准确率排行
        <el-col :span="3" :offset="2">
          <el-row>
            <el-col :offset="9">
              <div class="top">
                <el-tooltip class="item" effect="dark" content="平均每次分类的准确率(分对的总数/带标签的总数 (总次数大于10上榜))" placement="top">
                  <el-button class="button">分类准确率</el-button>
                </el-tooltip>
              </div>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="5" :offset="13">
              <div class="biao">
                <el-table class="b" :data="tableData4">
                  <el-table-column prop="name" label="姓名"></el-table-column>
                  <el-table-column prop="rateAcc" :formatter="transformData3" label="准确率"></el-table-column>
                </el-table>
              </div>
            </el-col>
          </el-row>
        </el-col>
        -->
      </el-row>
    </div>
  </div>
</template>

<script>
import { text, index } from '../config/text'
import { checkAPI, getRank1API, getRank2API, webIfonAPI, listAnnotationProjectsAPI, selectAnnotationProjectAPI, getProjectSiteProgressAPI /* , getRank3API, getRank4API */ } from '../API'
export default {
  data () {
    return {
      width: '120vw',
      tableData1: [],
      tableData2: [],
      countp: 0,
      user: 0,
      marking: 0,
      images: 0,
      pendingDataCache: 0,
      batchDone: 0,
      annotationProjects: [],
      selectedProjectId: '',
      projectsLoading: false,
      startingExplore: false,
      statsProjectTitle: '请选择标注项目',
      // tableData3: [],
      // tableData4: [],
      // 配置文件导入自动化展示=
      text: text[index]
    };
  },
  computed: {
    pendingData () {
      return this.pendingDataCache < 0 ? 0 : this.pendingDataCache
    },
    completionPercent () {
      const done = this.batchDone || 0
      const total = done + (this.pendingData || 0)
      if (total <= 0) return 0
      return Number(((done / total) * 100).toFixed(2))
    },
    selectedProjectHint () {
      if (this.annotationProjects.length === 0) {
        return '登录后可加载可选标注项目'
      }
      if (!this.selectedProjectId) {
        return '请先选择项目，再点击开始标注'
      }
      const p = this.annotationProjects.find(x => x.id === this.selectedProjectId)
      return p ? `将标注：${p.displayName || p.id}` : ''
    }
  },
  async created () {
    await this.check()
    await this.loadAnnotationProjects()
    this.together1()
    this.together2()
    this.loadWebInfo()
  },
  // mounted () {
  //   window.addEventListener("scroll", this.getRank)
  // },
  // 登录后跳转首页并保存
  beforeCreate () {
    let search = window.location.search;
    if (search !== '') {
      localStorage.setItem("Token-Circus", search.substring(1));
    }
  },
  methods: {
    // // 完整率改成保留小数点后两位
    // transformData2 (row) {
    //   return (row.rateComplete * 100).toFixed(2) + '%'
    // },
    // // 准确率改成保留小数点后两位
    // transformData3 (row) {
    //   return (row.rateAcc * 100).toFixed(2) + '%'
    // },
    // getRank () {
    //   if (window.scrollY >= 500) {
    //     this.together2()
    //     this.together3()
    //     this.together4()
    //     window.removeEventListener("scroll", this.getRank)
    //   }
    // },
    projectOptionLabel (p) {
      return p.displayName || p.id
    },
    async loadAnnotationProjects () {
      if (!localStorage.getItem('umtId')) return
      this.projectsLoading = true
      try {
        const res = await listAnnotationProjectsAPI()
        if (res.data.code !== 1 || !res.data.data) return
        const data = res.data.data
        this.annotationProjects = data.projects || []
        this.selectedProjectId = ''
      } catch (e) {
        // 未登录或接口不可用时静默
      } finally {
        this.projectsLoading = false
      }
    },
    // 点击开始按钮：先选定项目再进入标注页
    async ks () {
      if (this.startingExplore) return
      if (!this.selectedProjectId) {
        this.$message.warning(this.annotationProjects.length ? '请先选择标注项目' : '请先登录后再开始标注')
        return
      }
      this.startingExplore = true
      try {
        const res = await selectAnnotationProjectAPI(this.selectedProjectId)
        if (res.data.code !== 1) {
          this.$message.error(res.data.message || '选择项目失败')
          return
        }
        sessionStorage.setItem('classProjectChosen', this.selectedProjectId)
        this.$router.push({ path: '/home/class' })
        this.$bus.$emit('openDemandList1')
      } catch (e) {
        this.$message.error('请先登录后再开始标注')
      } finally {
        this.startingExplore = false
      }
    },
    // 分类总数
    async together1 () {
      const res = await getRank1API({})
      if (res.data.code == 1) {
        this.tableData1 = res.data.data
      }
    },
    // 异常总数
    async together2 () {
      const res = await getRank2API({})
      if (res.data.code == 1) {
        this.tableData2 = res.data.data
      }
    },
    onProjectPickChange () {
      this.loadProjectStats()
    },
    async loadWebInfo () {
      const res = await webIfonAPI({})
      if (res.data.code == 1 && res.data.data) {
        this.countp = res.data.data.t0 || 0
        this.user = res.data.data.t1 || 0
      }
      await this.loadProjectStats()
    },
    async loadProjectStats () {
      if (!this.selectedProjectId) {
        this.statsProjectTitle = '请选择标注项目'
        this.marking = 0
        this.images = 0
        this.pendingDataCache = 0
        this.batchDone = 0
        return
      }
      const p = this.annotationProjects.find(x => x.id === this.selectedProjectId)
      this.statsProjectTitle = (p && p.displayName) ? `${p.displayName}项目` : `${this.selectedProjectId}项目`
      try {
        const res = await getProjectSiteProgressAPI(this.selectedProjectId)
        if (res.data.code === 1 && res.data.data) {
          const d = res.data.data
          this.marking = d.marking || 0
          this.images = d.images || 0
          this.pendingDataCache = d.pending || 0
          this.batchDone = d.batchDone || 0
        }
      } catch (e) {
        // 后端未部署新接口时保持默认
      }
    },
    // // 平均完整率
    // async together3 () {
    //   const res = await getRank3API({})
    //   if (res.data.code == 1) {
    //     this.tableData3 = res.data.data
    //   }
    // },
    // // 平均准确率
    // async together4 () {
    //   const res = await getRank4API({})
    //   if (res.data.code == 1) {
    //     this.tableData4 = res.data.data
    //   }
    // },

    // 校验接口
    async check () {
      const res = await checkAPI({})
      if (res.data.code == 1) {
        localStorage.setItem("umtId", res.data.data.toString())
      }
    },
    operate () {
      this.$router.push({
        name: 'tutorial',
        params: {
          is: true,
        }
      })
      this.$bus.$emit('openDemandList')
    },
    shuju () {
      this.$router.push({
        name: 'tutorial',
        params: {
          iss: true,
        }
      })
      this.$bus.$emit('openDemandList')
      // 回到页面顶部
      window.scroll(0, 0)
    },
    star () {
      this.$router.push({
        name: 'tutorial',
        params: {
          star: true,
        }
      })
      this.$bus.$emit('openDemandList')
      window.scroll(0, 0)
    }
  }
};
</script>

<style lang="scss" scoped>
.el-button:focus,
.el-button:hover {
  color: #fff;
  border-color: #606266;
  background-color: #606266;
}

.el-table {
  background-color: rgba(85, 85, 85, 1);
}

.el-button {
  border-top-left-radius: 5px; //左上角
  border-top-right-radius: 5px; //右上角
  border-bottom-left-radius: 0px; //左上角
  border-bottom-right-radius: 0px; //右上角
}

.el-table__body-wrapper,
.el-table__footer-wrapper,
.el-table__header-wrapper {
  width: 100%;
  background-color: white;
}

::v-deep .el-table .el-table__cell {
  text-align: center;
  width: auto;
  background-color: rgba(85, 85, 85, 1);
  color: white;
  border: 0px;
  font-size: 18px;
}

::v-deep .el-table th.el-table__cell {
  width: auto;
  background-color: rgba(46, 46, 46, 1);
  color: #ffc300;
  border: 0px;
  font-size: 22px;
}

::v-deep .el-table tr:hover>td {
  background-color: gray !important;
}

.el-table::before {
  height: 0px;
}

// 中间内容

.main {
  background-image: url("../assets/bj.jpg");
  height: 520px;
  color: white;
  background-size: cover;
  line-height: 140px;

  .start-block {
    position: relative;
    width: 380px;
    line-height: normal;
  }

  .project-pick {
    margin-top: 20px;
    margin-bottom: 14px;
    display: flex;
    flex-direction: column;
    gap: 8px;
  }

  .project-pick-label {
    font-size: 16px;
    color: #ffc300;
    font-weight: bold;
  }

  .project-pick-hint {
    font-size: 12px;
    color: rgba(255, 255, 255, 0.85);
    line-height: 18px;
  }

  ::v-deep .project-pick-select {
    width: 100%;

    .el-input__inner {
      background: rgba(0, 0, 0, 0.45);
      border-color: #cc9900;
      color: #fff;
      height: 40px;
    }

    .el-input__inner::placeholder {
      color: rgba(255, 255, 255, 0.55);
    }
  }

  .but {
    height: 85px;
    width: 380px;
    text-align: left;
    background-color: #cc9900;
    line-height: 24px;
    border-radius: 10px;
    color: white;
    margin-top: 0;
    padding: 8px;
    padding-left: 24px;
    display: flex;
    flex-direction: column;
    cursor: pointer;
  }

  .but:hover {
    background-color: rgb(234, 192, 48);
  }

  .but--loading {
    opacity: 0.75;
    pointer-events: none;
  }

  .butt {
    height: 45px;
    width: 100%;
    text-align: center;
    line-height: 45px;
    border-radius: 10px;
    color: #cc9900;
    background-color: rgb(204, 204, 204);
    margin-top: 30px;
    font-size: 18px;
    cursor: pointer;
  }

  .butt1 {
    height: 45px;
    width: 100%;
    text-align: center;
    line-height: 45px;
    border-radius: 10px;
    color: #cc9900;
    background-color: rgb(204, 204, 204);
    margin-top: 30px;
    font-size: 18px;
    cursor: pointer;

    a {
      text-decoration: none;
      color: #cc9900;
    }
  }

  .butt:hover {
    color: white;
    background-color: rgb(184, 184, 184);
  }

  .butt1:hover a {
    color: white;
  }

  .butt1:hover {
    background-color: rgb(184, 184, 184);
  }

}

.main-one {
  background-color: black;
  color: white;
  line-height: 20px;
  height: 100%;

  .jj {
    font-size: 22px;
    padding-left: 20px;
    margin-bottom: 20px;
    border-left: 5px solid rgba(255, 195, 0, 1);
    margin-top: 20px;
  }

  .img-one {
    width: 350px;
    height: 100%;

    img {
      width: 400px;
      height: auto;
      opacity: 0.9;
      background-size: 100%;
    }
  }

  .img-two {
    width: 350px;
    height: 100%;
    position: absolute;
    top: 6px;

    img {
      width: 400px;
      height: auto;
      opacity: 0.9;
      background-size: 100%;

    }
  }
}

.bg {
  margin-top: 200px;
  background-color: orange;
  color: rgb(238, 238, 238);
  width: 95%;
  height: 60px;
  text-align: center;
  line-height: 60px;
  margin-left: 3vw;
  border-radius: 50px;
}

.rank-section {
  min-height: 620px;
  width: 100%;
}

.rank-col {
  transform: translateX(10px);
}

.stats-panel {
  margin-top: 50px;
  background: linear-gradient(180deg, #2f2f2f 0%, #1f1f1f 100%);
  border: 1px solid #5a5a5a;
  border-radius: 10px;
  padding: 24px 20px;
  color: #fff;
  min-height: 560px;
}

.stats-title {
  font-size: 26px;
  color: #ffc300;
  margin-bottom: 18px;
  text-align: center;
}

.stats-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
  padding: 10px 12px;
  background-color: rgba(255, 255, 255, 0.06);
  border-radius: 6px;
  font-size: 18px;
}

.stats-item b {
  color: #ffc300;
  font-size: 24px;
}

.progress-box {
  margin-top: 16px;
  padding: 14px;
  background-color: rgba(255, 255, 255, 0.05);
  border-radius: 6px;
}

.progress-title {
  font-size: 20px;
  margin-bottom: 10px;
}

.progress-text {
  color: #d6d6d6;
  font-size: 16px;
  margin-bottom: 10px;
}

.progress-circle-wrap {
  display: flex;
  justify-content: center;
  padding-top: 6px;
}

.biao {
  width: 108%;
  max-width: 520px;
  height: auto;
  margin-bottom: 50px;
  font-family: "none";
}

.b {
  width: 100%;
}

.button {
  width: 100%;
  height: auto;
  color: #ffc300;
  font-size: 26px;
  font-family: "阿里妈妈数黑体 Bold";
  background-color: black;
  border: 0px;
}

.top {
  margin-top: 50px;
}

.butt-one {
  height: 45px;
  width: 100%;
  text-align: center;
  line-height: 45px;
  border-radius: 1vw;
  color: rgb(200, 200, 200);
  background-color: rgb(51, 51, 51);
  font-size: 1rem;
  margin-top: 15px;
  cursor: pointer;
}

.butt-two {
  height: 45px;
  width: 100%;
  text-align: center;
  line-height: 45px;
  border-radius: 1vw;
  color: rgb(200, 200, 200);
  background-color: rgb(51, 51, 51);
  font-size: 1rem;
  cursor: pointer;
  position: relative;
  z-index: 999;
  margin-top: 15px;
}

.butt-one:hover {
  color: white;
}

.butt-two:hover {
  color: white;
}

// @media (max-width: 991px) {
//   .img-one {
//     img {
//       max-width: 380px;
//       max-height: 300px;
//     }
//   }
// }</style>
../config/text